import React from 'react';
import moment from 'moment';
import { convertSimCardActivationProcessStatus } from '../../../../helpers/converters';

const adminOptions = [
    {key:"DELETE", label:"Delete Meter"},
    {key:"EDIT", label:"Edit Meter"},
]
class MeterSimActivations  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        const processes = this.props.processes;
        if(!processes) return null;
        return <>

            <div class="table-responsive-xxl">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" style={{width:"220px"}}>Iccid</th>
                            <th scope="col" style={{width:"130px"}}>Status</th>
                            <th scope="col" style={{width:"200px"}}>Started Date</th>
                            <th scope="col" style={{width:"200px"}}>Completed Date</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {processes.map(h=>{

                            return <tr>
                                <td>{h.iccid}</td>
                                <td>{convertSimCardActivationProcessStatus(h.status)}</td>
                                <td>{moment((new Date(h.createdDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                <td>{h.completionDate && moment((new Date(h.completionDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                <td className='text-end'>
                                    <a className='btn btn-sm btn-primary' href={`/#/sim-activation-process/details/${h.id}`} target='_blank'>Open</a>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </>
    }
}

export default MeterSimActivations;
